export default __webpack_public_path__ + "static/personal-73dde00e35b57d191314c7b3ab0aa2ee.jpg";